import { __assign } from "tslib";
import * as React from 'react';
import { themes } from '../../ThemeOptions';
var BootStrapTbody = React.lazy(function () {
    return import('../../bootstrap-table-components/components/BTTbody');
});
var bootStrapTbody = function (props) {
    return React.createElement(BootStrapTbody, __assign({}, props));
};
export var Tbody = function (props) {
    var componentToDisplay = bootStrapTbody(props);
    switch (props.ioTheme.uiLibrary) {
        case 'bootstrap':
            componentToDisplay = bootStrapTbody(props);
    }
    return React.createElement(React.Fragment, null, componentToDisplay);
};
Tbody.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default Tbody;
//# sourceMappingURL=Tbody.js.map